import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  ICompanyDetails,
  ICompanyInfo,
  IRequiredInfo,
  IGrowthAndRetention,
  IOperationalEfficiency,
  IHeadCount
} from 'interfaces/store/companyInfo';

const initialState: ICompanyInfo = {
  requiredInfo: {
    status: null,
    currentARR: null,
    revenue: null,
    fcfMargin: null,
    avgDealSize: null,
    totalHeadcount: null,
    grossMargin: null,
    yoyARR: null,
    arrPerFTE: null,
    ruleOf40: null
  },
  growthAndRetention: {
    newLogoArrOfGrossNew: null,
    expansionArrOfGrossNew: null,
    quickRatio: null,
    netDollarRetention: null,
    grossDollarRetention: null,
    newLogoVelocity: null,
    newLogoArr: null,
    expansionArr: null
  },
  operationalEfficiency: {
    burnMultiple: null,
    netMagicNumber: null,
    rD: null,
    gA: null,
    sM: null,
    cacPaybackPeriod: null,
    rdPercent: null,
    gaPercent: null,
    smPercent: null,
    totalOpex: null
  },
  headCount: {
    opexPerFTE: null,
    rDHead: null,
    gAHead: null,
    sMHead: null,
    otherHead: null,
    rDHeadPercent: null,
    gAHeadPercent: null,
    sMHeadPercent: null,
    otherHeadPercent: null
  },
  companyDetails: {
    companyLogoURL: localStorage.getItem('companyLogoURL') || null,
    companyColor: '',
    companyWebsite: ''
  },
  email: '',
  isEntered: false
};

const companyInfoSlice = createSlice({
  name: 'companyInfo',
  initialState: initialState,
  reducers: {
    setCompanyDetails(state, action: PayloadAction<Partial<ICompanyDetails>>) {
      state.companyDetails = {
        ...state.companyDetails,
        ...action.payload
      };
    },
    setRequiredInfo(state, action: PayloadAction<Partial<IRequiredInfo>>) {
      state.requiredInfo = {
        ...state.requiredInfo,
        ...action.payload
      };
    },
    setGrowthAndRetention(
      state,
      action: PayloadAction<Partial<IGrowthAndRetention>>
    ) {
      state.growthAndRetention = {
        ...state.growthAndRetention,
        ...action.payload
      };
    },
    setOperationalEfficiency(
      state,
      action: PayloadAction<Partial<IOperationalEfficiency>>
    ) {
      state.operationalEfficiency = {
        ...state.operationalEfficiency,
        ...action.payload
      };
    },
    setHeadCount(state, action: PayloadAction<Partial<IHeadCount>>) {
      state.headCount = {
        ...state.headCount,
        ...action.payload
      };
    },
    setCompanyEmail(state, action: PayloadAction<string>) {
      state.email = action.payload;
    },
    setIsEntered(state, action: PayloadAction<boolean>) {
      state.isEntered = action.payload;
    },
    resetCompanyInfo(state) {
      state.companyDetails = {
        companyLogoURL: localStorage.getItem('companyLogoURL') || null,
        companyColor: '',
        companyWebsite: ''
      };
      state.requiredInfo = {
        status: null,
        currentARR: null,
        revenue: null,
        fcfMargin: null,
        avgDealSize: null,
        totalHeadcount: null,
        grossMargin: null,
        yoyARR: null,
        arrPerFTE: null,
        ruleOf40: null
      };
      state.growthAndRetention = {
        newLogoArrOfGrossNew: null,
        expansionArrOfGrossNew: null,
        quickRatio: null,
        netDollarRetention: null,
        grossDollarRetention: null,
        newLogoVelocity: null,
        newLogoArr: null,
        expansionArr: null
      };
      state.operationalEfficiency = {
        burnMultiple: null,
        netMagicNumber: null,
        rD: null,
        gA: null,
        sM: null,
        cacPaybackPeriod: null,
        rdPercent: null,
        gaPercent: null,
        smPercent: null,
        totalOpex: null
      };
      state.headCount = {
        opexPerFTE: null,
        rDHead: null,
        gAHead: null,
        sMHead: null,
        otherHead: null,
        rDHeadPercent: null,
        gAHeadPercent: null,
        sMHeadPercent: null,
        otherHeadPercent: null
      };
      state.email = '';
      state.isEntered = false;
    }
  }
});

export const {
  setCompanyDetails,
  setRequiredInfo,
  setGrowthAndRetention,
  setOperationalEfficiency,
  setHeadCount,
  setCompanyEmail,
  setIsEntered,
  resetCompanyInfo
} = companyInfoSlice.actions;

export default companyInfoSlice.reducer;
